import { useEffect, useState } from "react";

const useLoader = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  return { loading };
};

export default useLoader;
